import { render } from "./FortyTwo.vue?vue&type=template&id=4f826768&scoped=true"
import script from "./FortyTwo.vue?vue&type=script&lang=js"
export * from "./FortyTwo.vue?vue&type=script&lang=js"

import "./FortyTwo.vue?vue&type=style&index=0&id=4f826768&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f826768"]])

export default __exports__